export const name = "CSC";
export const summary = `Computes the cosecant of \`X\`.`;
export const reference = `
## CSC

Computes the cosecant of \`X\`.

\`\`\`
CSC(X)
\`\`\`

### Description

Computes the cosecant of the input angle, which is in radians.\`X\` can be any data type that coerces to \`FLOAT64\`. Supports the \`SAFE.\` prefix.

| X | CSC(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| \`0\` | \`Error\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT CSC(100) AS a, CSC(-1) AS b, SAFE.CSC(0) AS c;

/*----------------+-----------------+------*
 | a | b | c |
 +----------------+-----------------+------+
 | -1.97485753142 | -1.188395105778 | NULL |
 *----------------+-----------------+------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
